import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

function StatusMessage({ message, type = 'success', onClose }) {
  useEffect(() => {
    if (message) {
      const timer = setTimeout(onClose, 3000);
      return () => clearTimeout(timer);
    }
  }, [message, onClose]);

  if (!message) return null;

  return (
    <div 
      className={`status-message ${type === 'error' ? 'error' : ''}`}
      onClick={onClose}
    >
      {message}
    </div>
  );
}

StatusMessage.propTypes = {
  message: PropTypes.string,
  type: PropTypes.oneOf(['success', 'error']),
  onClose: PropTypes.func.isRequired
};

export default StatusMessage;
